<div class="table-content">

  <table class="basic-table desktop">
    <thead class="basic-table__head">
      <tr>
        <th></th>
        @if (this.listColumnToDisplay.includes(columns.Episodio)) {
          <th>Episódio</th>
        }
        @if (this.listColumnToDisplay.includes(columns.Senha)) {
          <th>Senha</th>
        }
        @if (this.listColumnToDisplay.includes(columns.Entrada)) {
          <th>Entrada</th>
        }
        @if (this.listColumnToDisplay.includes(columns.Prioridade)) {
          <th>Prioridade</th>
        }
        @if (this.listColumnToDisplay.includes(columns.LinhaDeCuidado)) {
          <th>Linha de<br> Cuidado</th>
        }
        @if (this.listColumnToDisplay.includes(columns.Gravidade)) {
          <th>Gravidade</th>
        }
        @if (this.listColumnToDisplay.includes(columns.NomePaciente)) {
          <th>Nome do <br>Paciente</th>
        }
        @if (this.listColumnToDisplay.includes(columns.DataNascimento)) {
          <th>Data de nascimento</th>
        }
        @if (this.listColumnToDisplay.includes(columns.NomeMae)) {
          <th>Nome da mãe</th>
        }
        @if (this.listColumnToDisplay.includes(columns.LocalizacaoAtual)) {
          <th matTooltip="Serviço/Setor/Sala">Localização atual</th>
        }
        @if (this.listColumnToDisplay.includes(columns.TempoEspera)) {
          <th matTooltip="Horas:Minutos:Segundos">Tempo de<br> espera</th>
        }
        @if (this.listColumnToDisplay.includes(columns.Situacao)) {
          <th>Situação</th>
        }
        @if (this.listColumnToDisplay.includes(columns.ProfissionalResponsavel)) {
          <th>Profissional<br>Responsável</th>
        }
        @if (this.listColumnToDisplay.includes(columns.Procedimentos)) {
          <th>Procedimentos</th>
        }
        <th></th>
      </tr>
    </thead>
    <tbody class="basic-table__body">
      @for (item of listPatient; track item; let index = $index) {
        <tr class="basic-table__body__row">
          <td class="truncate">
            <span class="material-symbols-outlined eye-complete-journey" (click)="openCompleteJourney(item.idEpisode)">visibility</span>
          </td>
          @if (this.listColumnToDisplay.includes(columns.Episodio)) {
            <td class="truncate"><span>{{item.idEpisode}}</span></td>
          }
          @if (this.listColumnToDisplay.includes(columns.Senha)) {
            <td class="truncate">
              <div class="display-in-ticket"><span>{{item.fullTicket}}</span>
              @if (item.isSchedule) {
                <span class="display-in-schedule">
                  <mat-icon
                    matTooltip="{{ item.dateStartSchedule | date: 'dd/MM/yyyy' }} - {{ item.dateStartSchedule | date: 'HH:mm' }}h"
                    matTooltipPosition="above" class="reduce-icon-schedule">calendar_month
                  </mat-icon>
                </span>
              }
            </div>
          </td>
        }
        @if (this.listColumnToDisplay.includes(columns.Entrada)) {
          <td class="truncate"><span>{{item.ticketDatetimeInclusion | date: 'dd/MM/yyyy
          HH:mm'}}</span></td>
        }
        @if (this.listColumnToDisplay.includes(columns.Prioridade)) {
          <td class="truncate">
            @for (priority of item.listPriority; track priority) {
              <span>
                @if (item.idPriority !== overEighty && item.idPriority !== overSixty && item.idPriority !== autism) {
                  <mat-icon class="icon"
                    >{{priority.icon}}
                  </mat-icon>
                }
                @if (item.idPriority === autism) {
                  <img src="assets/images/autism-symbol.png" class="img-adjust"/>
                }
                @if ((item.idPriority === overEighty || item.idPriority === overSixty) && item.idPriority !== autism) {
                  <span class="icon"
                  >{{priority.icon}}</span>
                }
              </span>
            }
          </td>
        }
        @if (this.listColumnToDisplay.includes(columns.LinhaDeCuidado)) {
          <td class="truncate">
            @if (item.idCareLinePriorityStatus != careLinePriorityStatusDenied && item.careLinePriorityisDefaultIcon) {
              <span
                class="icon material-symbols-outlined"
              matTooltip="{{item.careLinePriorityName}}">{{item.careLinePriorityIcon}}</span>
            }
            @if (!item.careLinePriorityisDefaultIcon) {
              <img matTooltip="{{item.careLinePriorityName}}" src="{{item.careLinePriorityIconFilePath}}" class="img-adjust"/>
            }
          </td>
        }
        @if (this.listColumnToDisplay.includes(columns.Gravidade)) {
          <td>
            <div class="gravity-container">
              @if (item.lastTriage) {
                <div class="gravity" [style.background-color]="item.lastTriage.gravityColorCode"
                matTooltip="{{item.lastTriage.gravityName}}"></div>
              }
            </div>
          </td>
        }
        @if (this.listColumnToDisplay.includes(columns.NomePaciente)) {
          <td class="truncate"><span>{{item.patientSocialName ? item.patientSocialName :
          item.patientName}}</span></td>
        }
        @if (this.listColumnToDisplay.includes(columns.DataNascimento)) {
          <td class="truncate"><span>{{item.birthDate | date: 'dd/MM/yyyy'}}</span></td>
        }
        @if (this.listColumnToDisplay.includes(columns.NomeMae)) {
          <td class="truncate"><span>{{item.motherName}}</span></td>
        }
        @if (this.listColumnToDisplay.includes(columns.LocalizacaoAtual)) {
          <td class="truncate"
            matTooltip="{{item.serviceName }} {{item.sectorName ? '/ ' + item.sectorName : '' }} {{item.roomName ? '/ ' + item.roomName : ''}}">
            <span>
              {{item.locationDisplay}}
            </span>
          </td>
        }
        @if (this.listColumnToDisplay.includes(columns.TempoEspera)) {
          <td class="truncate"
            matTooltip="Tempo total na instituição: {{item.totalEpisodeTimeHours}}:{{item.totalEpisodeTimeMinutes}}:{{item.totalEpisodeTimeSeconds}}">
            <span>{{item.waitingTimeHours}}:{{item.waitingTimeMinutes}}:{{item.waitingTimeSeconds}}
            </span>
          </td>
        }
        @if (this.listColumnToDisplay.includes(columns.Situacao)) {
          <td class="truncate" matTooltip="Número de chamadas: {{item.ticketCallCount}}"
            [matTooltipClass]="'my-tooltip'">
            <app-status-bullet [idStatusQueue]="item.idStatusQueue"
            [statusQueueName]="item.statusQueueName"></app-status-bullet>
          </td>
        }
        @if (this.listColumnToDisplay.includes(columns.ProfissionalResponsavel)) {
          <td class="truncate"><span>{{item.attendantUserName}}</span></td>
        }
        @if (this.listColumnToDisplay.includes(columns.Procedimentos)) {
          <td class="truncate">
            @if (item.hasPrescription) {
              <span class="material-symbols-outlined"
              matTooltip="Medicação">vaccines</span>
            }
            @if (item.hasProcedure) {
              <span class="material-symbols-outlined"
              matTooltip="Procedimento">healing</span>
            }
            @if (item.hasInternalSadt) {
              <span class="material-symbols-outlined"
              matTooltip="Exame interno">biotech</span>
            }
            @if (item.hasExternalSadt) {
              <span class="material-symbols-outlined"
              matTooltip="Exame externo">output</span>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
</div>
<cdk-accordion class="accordion mobile">
  @for (item of listPatient; track item; let index = $index) {
    <cdk-accordion-item #accordionItem="cdkAccordionItem"
      class="accordion-item" role="button" tabindex="0" [attr.id]="'accordion-header-' + index"
      [attr.aria-expanded]="accordionItem.expanded" [attr.aria-controls]="'accordion-body-' + index">
      <div [ngClass]="{'accordion-item-header-expanded': accordionItem.expanded}" class="accordion-item-header"
        (click)="accordionItem.toggle()">
        <div class="flex-space-between"><span class="truncate bold padding-right-0">Token</span><span
      class="truncate">{{item.fullTicket}}</span></div>
      <div class="flex-space-between"><span class="truncate bold padding-right-0">Nome do
      paciente</span><span class="truncate">{{item.patientSocialName ?
    item.patientSocialName : item.patientName}}</span></div>
    <div class="flex-space-between"><span class="truncate bold padding-right-0">Prioridade
      da
    senha</span>
    @for (priority of item.listPriority; track priority) {
      <span class="truncate">
        @if (priority.idPriority !== overEighty && priority.idPriority !== overSixty) {
          <mat-icon class="icon"
            >{{priority.icon}}
          </mat-icon>
        }
        @if (item.idPriority === autism) {
          <img src="assets/images/autism-symbol.png" class="img-adjust"/>
        }
        @if (priority.idPriority === overEighty || priority.idPriority === overSixty) {
          <span class="icon"
          >{{priority.icon}}</span>
        }
      </span>
    }
  </div>
  <div class="flex-space-between">
    <span class="truncate bold padding-right-0">Linha de Cuidado</span>
    @if (item.careLinePriorityisDefaultIcon) {
      <span class="material-symbols-outlined"
      matTooltip="{{item.careLinePriorityName}}">{{item.careLinePriorityIcon}}</span>
    }
    @if (!item.careLinePriorityisDefaultIcon) {
      <img matTooltip="{{item.careLinePriorityName}}" src="{{item.careLinePriorityIconFilePath}}" class="img-adjust"/>
    }
  </div>
  <div class="flex-space-between"><span class="truncate bold padding-right-0">Gravidade</span>
  <span class="truncate">
    <div class="gravity-container">
      @if (item.listTriage && item.listTriage.length > 0) {
        <div class="gravity"
        [style.background-color]="item.listTriage[0].gravityColorCode"></div>
      }
    </div>
  </span>
</div>
</div>
<div class="accordion-item-body" role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
  [attr.id]="'accordion-body-' + index" [attr.aria-labelledby]="'accordion-header-' + index">
  <div class="feature-content">
    <div class="padding-x">
      <div class="truncate"><span class="material-symbols-outlined eye-complete-journey">visibility</span></div>
      <div class="flex-space-between padding-y"><span
      class="truncate bold padding-right-0">Episódio</span> <span
    class="truncate">{{item.idEpisode}}</span></div>
    <div class="flex-space-between padding-y"><span class="truncate bold padding-right-0">Responsável
      pelo
    atendimento</span>
    <span class="truncate">{{item.attendantUserName}}</span>
  </div>
  <div class="flex-space-between padding-y"><span class="truncate bold padding-right-0">Nº de chamadas
  da senha</span>
  <span class="truncate">{{item.ticketCallCount}}</span>
</div>
<div class="flex-space-between padding-y"><span class="truncate bold padding-right-0">Retirada da
  senha</span> <span class="truncate">{{item.ticketDatetimeInclusion}}</span></div>
  <div class="flex-space-between padding-y"><span class="truncate bold padding-right-0">Tempo de
    espera</span> <span class="truncate">{{item.waitingTime}}</span></div>
    <div class="flex-space-between padding-y"><span
    class="truncate bold padding-right-0">Situação</span>
    <span class="truncate">
      <app-status-bullet [idStatusQueue]="item.idStatusQueue"
        [statusQueueName]="item.statusQueueName">
      </app-status-bullet>
    </span>
  </div>
  <div class="flex-space-between padding-y">
    <span class="truncate bold padding-right-0">Profissional Responsável</span>
    <span class="truncate">{{item.attendantUserName}}</span>
  </div>
  <div class="flex-space-between padding-y">
    <span class="truncate bold padding-right-0">Procedimentos</span>
    @if (hasPrescription) {
      <span class="material-symbols-outlined"
      matTooltip="Medicação">vaccines</span>
    }
    @if (hasProcedure) {
      <span class="material-symbols-outlined"
      matTooltip="Procedimento">healing</span>
    }
    @if (hasXRay) {
      <span class="material-symbols-outlined"
      matTooltip="Raio-X">sensor_occupied</span>
    }
    @if (hasSadt) {
      <span class="material-symbols-outlined" matTooltip="Exame">biotech</span>
    }
  </div>
</div>
</div>
</div>
</cdk-accordion-item>
}
</cdk-accordion>